import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Hedit } from './views/Hedit';

const LayoutComponent = () => <Hedit />;

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Hedit)
	.setHudVisible(true)
	.build();

export default Layout;
